import { z } from "zod";

const getConfigPortalCredentialsSchema = z.object({
  search: z.string().nullable().optional(),
  includeInactive: z.boolean().nullable().optional(),
  page_number: z.number().int().min(1),
  page_size: z.number().int().min(1).max(100),
});

const createConfigPortalCredentialSchema = z.object({
  purchaserId: z.number().int().positive(),
  portalKey: z.string().trim().min(1).max(100),
  portalUserName: z.string().trim().min(1).max(255),
  portalPassword: z.string().nullable().optional(),
  isActive: z.boolean(),
  metadata: z.unknown().nullable().optional(),
});

const updateConfigPortalCredentialSchema = z.object({
  id: z.number().int().positive(),
  portalUserName: z.string().trim().min(1).max(255),
  portalPassword: z.string().nullable().optional(),
  isActive: z.boolean(),
  metadata: z.unknown().nullable().optional(),
});

const deleteConfigPortalCredentialSchema = z.object({
  id: z.number().int().positive(),
});

export class GetConfigPortalCredentialsDTO {
  readonly search: string | null;
  readonly includeInactive: boolean;
  readonly page_number: number;
  readonly page_size: number;

  constructor(params: {
    search?: string | null;
    includeInactive?: boolean | null;
    page_number: number;
    page_size: number;
  }) {
    const parsed = getConfigPortalCredentialsSchema.parse({
      search: params.search ?? null,
      includeInactive: params.includeInactive ?? true,
      page_number: params.page_number,
      page_size: params.page_size,
    });
    this.search = parsed.search ?? null;
    this.includeInactive = parsed.includeInactive ?? true;
    this.page_number = parsed.page_number;
    this.page_size = parsed.page_size;
  }
}

export class CreateConfigPortalCredentialDTO {
  readonly purchaserId: number;
  readonly portalKey: string;
  readonly portalUserName: string;
  readonly portalPassword: string | null;
  readonly isActive: boolean;
  readonly metadata: unknown | null;

  constructor(params: {
    purchaserId: number;
    portalKey: string;
    portalUserName: string;
    portalPassword?: string | null;
    isActive: boolean;
    metadata?: unknown | null;
  }) {
    const parsed = createConfigPortalCredentialSchema.parse(params);
    this.purchaserId = parsed.purchaserId;
    this.portalKey = parsed.portalKey;
    this.portalUserName = parsed.portalUserName;
    this.portalPassword = parsed.portalPassword ?? null;
    this.isActive = parsed.isActive;
    this.metadata = parsed.metadata ?? null;
  }
}

export class UpdateConfigPortalCredentialDTO {
  readonly id: number;
  readonly portalUserName: string;
  readonly portalPassword: string | null;
  readonly isActive: boolean;
  readonly metadata: unknown | null;

  constructor(params: {
    id: number;
    portalUserName: string;
    portalPassword?: string | null;
    isActive: boolean;
    metadata?: unknown | null;
  }) {
    const parsed = updateConfigPortalCredentialSchema.parse(params);
    this.id = parsed.id;
    this.portalUserName = parsed.portalUserName;
    this.portalPassword = parsed.portalPassword ?? null;
    this.isActive = parsed.isActive;
    this.metadata = parsed.metadata ?? null;
  }
}

export class DeleteConfigPortalCredentialDTO {
  readonly id: number;

  constructor(params: { id: number }) {
    const parsed = deleteConfigPortalCredentialSchema.parse(params);
    this.id = parsed.id;
  }
}
